export const OPEN_SEARCH = 'OPEN_SEARCH';
export const CLOSE_SEARCH = 'CLOSE_SEARCH';
export const CLOSE_NAVIGATION = 'CLOSE_NAVIGATION';
